import React, { useState, useEffect, useRef } from 'react';
import './controlsCompliance.css';
import { getDecodedToken, getSector } from '../../service/service';
import UnderDevelopment from '../../assets/under-construction.svg';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { dashboardUrl } from '../../service/config';


const controlTestDashboard = () => {
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const dataFetchedRef = useRef(false);
	const [, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			setSectorOptionsList(sectorRes.data.sector.map((x: any) => x.name));
		}
	}
	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;

		if (userSector === 'all') fetchSectorOptionsData();
		let storedSectorFilter = localStorage.getItem('presto-summary-sector-filter')
			? JSON.parse(localStorage.getItem('presto-summary-sector-filter') ?? '')
			: null;
		if (storedSectorFilter) {
			setCheckedList(storedSectorFilter);
			setCurrSectorFilter(storedSectorFilter);
		}
	});
	return (

		<div className="controlCompliance-denodo-panel">
			<div>
				{dashboardUrl.controlsTestingDashboard !== undefined ? (
					<div style={{ marginTop: '37px' }}>
						<AnalyticsVisualization
							params={{
								dashboardUrl: dashboardUrl.controlsTestingDashboard,
								className: 'controlsTestingIframeContainer',
								otherParams: {
									from: 'now-6h',
									to: 'now'
								},
								seamless: true
							}}
						/>
					</div>
				) : (
					<div style={{ position: 'absolute', left: '45%', top: '50%', color: 'darkgray' }}>
						<img src={UnderDevelopment} alt="Dashboard under development" />
						<p style={{ position: 'relative', right: '25%', margin: '0' }}>Dashboard under development!</p>
					</div>
				)}
			</div>

		</div>
	);
};

export default controlTestDashboard;
